import { useEffect } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;
const SESSION_KEY = "dara_visitor_session";
const VISITOR_ID_KEY = "dara_visitor_id"; // Phase 25.13ad — persistent cross-day fingerprint

// Phase 36.13 — Native pageview tracker.
// Fires once per route mount on PUBLIC pages. Captures URL path, referrer,
// UTM params, viewport size, plus a per-browser session id (regenerates
// each visit). Backend hashes IP with daily salt for privacy.
function getOrMintSession() {
  if (typeof window === "undefined") return "";
  let s = sessionStorage.getItem(SESSION_KEY);
  if (!s) {
    s = `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
    sessionStorage.setItem(SESSION_KEY, s);
  }
  return s;
}

// Phase 25.13ad — Persistent visitor_id in localStorage. Unlike visitor_session
// (sessionStorage, per-tab), this survives across tabs, browser restarts, and
// days. Used by the visitor dashboard to detect returning visitors and bump
// their engagement score. Cleared only when the user clears localStorage.
function getOrMintVisitorId() {
  if (typeof window === "undefined") return "";
  let v = localStorage.getItem(VISITOR_ID_KEY);
  if (!v) {
    v = `v_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 12)}`;
    localStorage.setItem(VISITOR_ID_KEY, v);
  }
  return v;
}

// Phase 36.17 — exported helper used by lead-capture forms (Industry,
// Founder's Guide). Returns the same id that getOrMintSession created on
// first pageview, so the lead row gets stamped with the visitor's session
// and we can show their full journey on the admin Leads page.
export function getVisitorSession() {
  return getOrMintSession();
}

export function getVisitorId() {
  return getOrMintVisitorId();
}

export default function usePageview(path) {
  useEffect(() => {
    if (typeof window === "undefined") return;
    const params = new URLSearchParams(window.location.search);
    // Phase 25.13m — flag pageviews from a logged-in super-admin so they
    // get excluded from /admin/visitors by default.
    const isAdminSession = localStorage.getItem("dara_is_super_admin") === "1";
    const body = {
      path: path || window.location.pathname,
      referrer: document.referrer || "",
      user_agent: navigator.userAgent || "",
      utm_source: params.get("utm_source") || "",
      utm_medium: params.get("utm_medium") || "",
      utm_campaign: params.get("utm_campaign") || "",
      utm_content: params.get("utm_content") || "",
      screen_w: window.innerWidth || null,
      screen_h: window.innerHeight || null,
      visitor_session: getOrMintSession(),
      visitor_id: getOrMintVisitorId(),
      is_admin_session: isAdminSession,
    };
    // Fire-and-forget; never raises if the backend is briefly down.
    axios.post(`${API}/public/pageview`, body).catch(() => {});
  }, [path]);
}
